import { ADMIN_PREFIX } from "@cti-workspace/helpers";
import { getApi } from "./api";

export default async function getChainIds() {
	const url = `/${ADMIN_PREFIX}/getAllSupportBlockchains`;
	return getApi(url);
}
